<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/wishlists/shared/wishlist-widget/wishlist-widget.component.ts
-->
<ng-template #anchor></ng-template>
